import { gql } from "@apollo/client";

export const ADD_ATTENDANCE_RECORDS = gql`
  mutation AddAttendanceRecords($attendanceRecords: AddAttendanceRecordsModelInput) {
    addAttendanceRecords(attendanceRecords: $attendanceRecords) {
      hasError
      messages
    }
  }
`;

export const GET_ATTENDANCE_RECORDS = gql`
  query AttendanceRecords($eventId: String, $eventIdHash: String) {
    attendanceRecords(eventId: $eventId, eventIdHash: $eventIdHash) {
      attendanceRecords {
        learnerId
        firstName
        lastName
        email
      }
      validationErrors {
        errorMessage
        errorCode
      }
      messages
      hasError
    }
  }
`;
